<template>
	<div id="planinbj">
		<HrrBreadcrumb PMname="岗位计划管理" CMname="京外调干岗位申报管理" />
		<HrrMainLayout>
			<template slot="searh">
				<el-form inline :model="searchform">
					<el-form-item label="计划：">
                        <el-select v-model="searchform.planId"  placeholder="请选择">
                            <el-option v-for="item in planIdData" :key="item.planId" :label="item.planName" :value="item.planId">
                            </el-option>
                        </el-select>
                    </el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">查询</el-button>
					</el-form-item>
				</el-form>
			</template>
			<template slot="buttons">
				<el-button-group>
					<el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick" >新增</el-button>
					<el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick" >编辑</el-button>
					<el-button type="primary" icon="el-icon-delete" size="small" @click="delclick" >删除</el-button>
				</el-button-group>
			</template>
			<template slot="table">
				<el-table  :data="tableData" ref="tableData" @cell-click="cellclick" @selection-change="selectionchange"
				border stripe style="width: 100%" v-loading="loading"  >
				<el-table-column type="selection" width="55" fixed="left" >
				</el-table-column>
                <el-table-column label="拟京外选调人员数量" fixed="left" width="210" >
                    <el-table-column prop="totalNum" label="总数" width="90" sortable></el-table-column>
                    <el-table-column prop="greenNum" label="其中符合绿色通道条件人员" width="120" sortable></el-table-column>
                </el-table-column>
				<el-table-column label="拟补充人员专业情况" >
					<el-table-column  v-for="item in majors" :label="item.name" :prop="item.fieldname" width="80">	
					</el-table-column>    
				</el-table-column>
				<el-table-column prop="creationDate" label="创建时间" width="170" sortable>
				</el-table-column>
				<el-table-column prop="creationBy" label="创建人" width="110">
				</el-table-column>
				<el-table-column label="操作" width="120"  fixed="right">
					<template slot-scope="scope">
						<el-button @click.stop="Rowview(scope.row)" type="text" size="small">查看</el-button>
						<el-button @click.stop="RowEdit(scope.row)" type="text"  size="small">编辑</el-button>
						<el-button @click.stop="Rowdelete(scope.row)" type="text"  size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</template>
		<template slot="Pagination">
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum"
			:page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
		    </el-pagination>
	    </template>
</HrrMainLayout>
</div>
</template>
<script>
	export default {
		name: 'planinbj',
		data(){
			return{
				searchform:{
					pageNum:1,
					pageSize:10,
					planId:"",
				},
				majors:[
				{id:"1",name:"机械",fieldname:"major1"},
                {id:"2",name:"电机、电器、电子",fieldname:"major2"},
                {id:"3",name:"动力",fieldname:"major3"},
                {id:"4",name:"化工",fieldname:"major4"},
                {id:"5",name:"土木建筑",fieldname:"major5"},
                {id:"6",name:"矿业冶金",fieldname:"major6"},
                {id:"7",name:"轻工纺织粮食",fieldname:"major7"},
                {id:"8",name:"地质水文测绘",fieldname:"major8"},
                {id:"9",name:"运输通讯",fieldname:"major9"},
                {id:"10",name:"管理",fieldname:"major10"},
                {id:"11",name:"理科",fieldname:"major11"},
                {id:"12",name:"农业",fieldname:"major12"},
                {id:"13",name:"林业",fieldname:"major13"},
                {id:"14",name:"医药",fieldname:"major14"},
                {id:"15",name:"文史",fieldname:"major15"},
                {id:"16",name:"外文",fieldname:"major16"},
                {id:"17",name:"财经",fieldname:"major17"},
                {id:"18",name:"政法",fieldname:"major18"},
                {id:"19",name:"体育",fieldname:"major19"},
                {id:"20",name:"文艺",fieldname:"major20"}],
				tableData:[],
				planIdData: [],
				total:0,
				loading:true,
				selectionRows:[],
			}
		},
		methods:{
			onSubmit(){
				this.searchform.insName=this.keyword;
				this.initData();
			},
			handleSizeChange(val) {
				this.searchform.pageSize=val;
				this.initData();
			},
			handleCurrentChange(val) {
				this.searchform.pageNum=val;
				this.initData();
			},
			Rowview(val){
				this.$route.meta.row=val;
				this.$router.push({path:'/plan/inbj/view/'+val.inbjId});
			},
			RowEdit(val){
				this.$route.meta.row=val;
				this.$router.push({path:'/plan/inbj/edit/'+val.inbjId});
			},
			Rowdelete(val){
				this.$confirm("确定要删除的记录么？","删除提示",{type:"warning"})
				.then(()=>{
					var Vuethis=this;
					this.$hrraxios.post(this.$api.plan.inbjDel,{inbjId:val.inbjId})
					.then((response)=>{
						var redata=response.data;
						if(redata.success==true){
							Vuethis.$message({message:"删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							Vuethis.$message({message:redata.prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
			},
			Addclick(){
				this.$router.push({path:'/plan/inbj/add/',});
			},
			editclick(){
				if(this.selectionRows.length==0)
				{
					this.$message({message:"请先选择一行在操作",type:"warning"});
					return;
				}
				if(this.selectionRows.length>1)
				{
					this.$message({message:"只能操作一行数据",type:"warning"});
					return;
				}
				this.$route.meta.row=this.selectionRows[0];
				this.$router.push({path:'/plan/inbj/edit/'+this.selectionRows[0].inbjId});
			},
			delclick(){
				if(this.selectionRows.length<1)
				{
					this.$message({message:"请先选择一行在删除",type:"warning"});
					return;
				}
				this.$confirm("确定要删除这些记录么？",{type:"warning"})
				.then(()=>{
					var loading = this.$loading({
						lock: true,
						text: '删除中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var Vuethis=this;
					var PostfunArr=[];
					this.selectionRows.forEach(myrow=>{
						var postRe=this.$hrraxios.post(this.$api.plan.inbjDel,{inbjId:myrow.inbjId});
						PostfunArr.push(postRe);
					});
					this.$axios.all(PostfunArr)
					.then(this.$axios.spread(function(){
						loading.close();
						//console.log(arguments);
						var isalldel=true;
						for(var i=0;i<arguments.length;i++){
							if(arguments[i].data.success==false)
							{
								isalldel=false;
							}
						}
						if(isalldel==true){
							Vuethis.$message({message:"全部删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							//有删除失败的未处理
						}
					}));
				})
				.catch((error)=>{
					Vuethis.$message({message:error,type:"danger"});
				});
			},
			cellclick(row, column, cell, event){
				this.$refs.tableData.toggleRowSelection(row);
			},
			selectionchange(selection){
				this.selectionRows=selection;
			},
			initData(){
				var Vuethis = this;
				this.loading = true;
                this.$hrraxios.get(this.$api.plan.inbjList, {
                        params: this.searchform
                    })
                    .then(function(response) {
                        Vuethis.loading = false;
						var data = response.data;
						// console.log(response)
                        if (data.success == true) {
							Vuethis.tableData = data.data.list;
							Vuethis.total=data.data.total;
                        } else {
                            Vuethis.$message.error(data.prompt);
                        }
                    })
                    .catch(function(error) {
                        Vuethis.loading = false;
                        console.log(error);
                    });
			},
			initParamsData(){
                this.$common.getplanlist(this,"planIdData");
            } 
		},
		beforeRouteLeave(to, from, next) {
			// 导航离开该组件的对应路由时调用
			to.meta.row=from.meta.row;
			next();
		},
		created(){
			var vuethis=this;
			document.onkeydown = function(e) {
				var key = window.event.keyCode;
				if (key == 13) {
					if(vuethis.keyword!=""){
						vuethis.onSubmit();
					}
				}
			};
			this.initData();
			this.initParamsData();
		}
	}
</script>
<style>
  .input-with-select {
    width: 110px;
  }
</style>
